import React from 'react'
import { Link, useLocation } from "react-router-dom";
import { usePhoneNumber } from "../hooks/usePhoneNumber";
import { PhoneCall } from 'lucide-react';
const NewNavbar = () => {
  const location = useLocation();
  // Pass current route pathname to your hook
  const {phone} = usePhoneNumber(location.pathname);

  return (
    <>
    <nav className="navbar bg-[#1A1A1A] sticky top-0 z-40 shadow-nav">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          {/* Logo */}
          <div className="flex items-center flex-shrink-0">
            <Link to="/" className="flex items-center space-x-2">
              <img
                src="/images/logos/newGoldenSparrowLogo.png"
                alt="Golden Sparrow"
                className="h-16 w-auto object-contain"
              />
            </Link>
          </div>
          {/* Dynamic Phone */}
          <div className="flex items-center gap-2">
            <button
              className="nav-gradient-btn"
              onClick={() => { window.location.href = `tel:${phone}` }}
            >
              <div className="nav-gradient-btn-content">
                <PhoneCall className='w-6 h-6 mr-3' />
                <span className="hidden lg:flex">{phone}</span>
                <span className="flex sm:flex md:flex lg:hidden">Call Now</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </nav>
    <style jsx>{`
.nav-gradient-btn {
  position: relative;
  background: linear-gradient(159.21deg, #FFD200 11.19%, #F7971E 101.23%);
  border: none;
  border-radius: 4px;
  padding: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  box-sizing: border-box;
}
.nav-gradient-btn-content {
  background: #000;
  margin: 1px;
  border-radius: 4px;
  padding: 8px 16px;
  font-size:20px;
  font-weight: 600;
  color: #fff;
  transition: all 0.3s ease-out;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
/* Hover state - full gradient background */
.nav-gradient-btn:hover {
  background: linear-gradient(159.21deg, #FFD200 11.19%, #F7971E 101.23%);
}
.nav-gradient-btn:hover .nav-gradient-btn-content {
  background: transparent;
  color: #000;
  margin: 1px;
  padding: 8px 16px;
}
/* Clicked/Active state - reversed gradient */
.nav-gradient-btn:active,
.nav-gradient-btn.clicked {
  background: linear-gradient(159.21deg, #F7971E 11.19%, #FFD200 101.23%);
}
.nav-gradient-btn:active .nav-gradient-btn-content,
.nav-gradient-btn.clicked .nav-gradient-btn-content {
  background: transparent;
  color: #000;
  margin: 1px;
  padding: 8px 16px;
}

@media screen and (max-width: 640px) {
  .nav-gradient-btn-content {
    font-size: 16px;
    }
    }
    `}</style>
    </>
  )
}

export default NewNavbar;
